import { Injectable } from '@angular/core';
import { RouteDataStoreService } from 'src/app/modules/aa-core/services/data-store/data-store.service';
import { AARouterURL } from '../../enums/routing.enum';
import { RoutePlannerDataModel } from 'src/app/modules/route-planner/models/route-model';
import { TrafficNewsModel } from 'src/app/modules/traffic-news/models/traffic-news-model';
import { MapsHotelsModel } from 'src/app/modules/maps-hotels/models/maps-hotels-model';
import { Router } from '@angular/router';
import { AppUtilityService } from 'src/app/core/services/app-utility/app-utility.service';
import { AppRouterService } from '../app-router/app-router.service';
import { AAConstant } from 'src/app/core/models/constants';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppRouterDataService extends AppRouterService {
  private routeDataModel: RoutePlannerDataModel;
  private trafficNewsModel: TrafficNewsModel;
  private mapsHotelsModel: MapsHotelsModel;
  onTabChange = new Subject();
  constructor(public router: Router, private readonly dataStore: RouteDataStoreService, public appUtilityService: AppUtilityService) {
    super(router);
    this.routeDataModel = this.dataStore.routeDataModel;
    this.trafficNewsModel = this.dataStore.trafficNewsModel;
    this.mapsHotelsModel = this.dataStore.mapsHotelsModel;
  }

  private updateRouteWithQueryParams(route: Array<AARouterURL>, urlData: any): void {
    this.router.navigate(route, urlData);
  }

  private updateRouteWithPath(urlData: any): void {
    this.router.navigate(urlData);
  }

  public updateURL(urlType: AARouterURL): void {
    switch (urlType) {
      case AARouterURL.ROUTE_PLANNER:
        this.updateRouteWithQueryParams([AARouterURL.ROUTE_PLANNER], { queryParams: this.routePlanerLink });
        break;
      case AARouterURL.TRAFFIC_NEWS:
        this.updateRouteWithPath(this.trafficNewsLink());
        break;
      case AARouterURL.MAP_HOTELS:
        this.updateRouteWithPath(this.mapsHotelsLink());
        break;
      // route planner print preview
      case AARouterURL.PRINT_PREVIEW:
        this.router.navigate([{ outlets: { [AARouterURL.OUTLET_PRINT]: [urlType] } }], { queryParams: this.routePlanerLink });
        break;
      case AARouterURL.PRINT_PREVIEW_CLOSE:
        this.router.navigate([{ outlets: { [AARouterURL.OUTLET_PRINT]: null, primary: [AARouterURL.ROUTE_PLANNER] } }], {
          queryParams: this.routePlanerLink
        });
        break;
      // map  print preview
      case AARouterURL.MAP_PRINT_PREVIEW:
        this.router.navigate([{ outlets: { [AARouterURL.OUTLET_PRINT]: [urlType] } }]);
        break;
      case AARouterURL.MAP_PRINT_PREVIEW_CLOSE:
        this.router.navigate([{ outlets: { [AARouterURL.OUTLET_PRINT]: null, primary: [AARouterURL.MAP_HOTELS] } }]);
        break;
    }
    this.onTabChange.next();
  }

  public get routePlanerLink(): any {
    const params: any = {};

    if (this.routeDataModel.FromLocation.validName() && this.routeDataModel.ToLocation.validName()) {
      params[AARouterURL._FROM] = this.routeDataModel.FromLocation.Name;
      params[AARouterURL._TO] = this.routeDataModel.ToLocation.Name;

      if (this.routeDataModel.ViaRoutes.length) {
        const locations = this.routeDataModel.ViaRoutes.map((route) => {
          return route.Name;
        }).filter((name) => {
          return name !== '';
        });
        params[AARouterURL._VIA] = locations.join(AARouterURL._SEPARATOR);
      }

      // route options
      const data = this.routeDataModel.OptionsData.encodeURL();
      if (data !== '') {
        params[AARouterURL._OPTIONS] = data;
      }
    }

    return params;
  }

  public trafficNewsLink(): Array<any> {
    const link: Array<any> = [AARouterURL.TRAFFIC_NEWS];
    const location = this.trafficNewsModel.locationModel;

    if (location.validName() && !location.isCurrentLocation()) {
      link.push(location.Name);
    }
    return link;
  }

  public mapsHotelsLink(): Array<any> {
    const link: Array<any> = [AARouterURL.MAP_HOTELS];
    const location = this.mapsHotelsModel.locationModel;

    if (location.validName() && !location.isCurrentLocation()) {
      link.push(location.Name);
    }

    return link;
  }
}
